import { configureStore } from '@reduxjs/toolkit'
import faqs from '../slice/faqs';
export const store = configureStore({
  reducer: {
    faqs: faqs,
  },
})